// extracted by mini-css-extract-plugin
export default {"container":"CreateAuction_container__AquFW","title":"CreateAuction_title__QPCI-"};